import { QueryErrorBoundary } from '@components/errors/QueryErrorBoundary'
import { ParentContactInfo } from '@features/parent-page/components/ParentContactInfo'
import { createFileRoute } from '@tanstack/react-router'
import { LoadingIndicator } from '@ui/LoadingIndicator'
import { Suspense } from 'react'

export const Route = createFileRoute('/_layout/parents/$parentId/contact-info')(
  {
    component: RouteComponent,
  },
)

function RouteComponent() {

    const { parentId } = Route.useParams();

    return (
        <QueryErrorBoundary title='Failed to load parent contact info'>
            <Suspense fallback={<LoadingIndicator resource='parent contact info'/>}>
                <ParentContactInfo parentId={parentId} />
            </Suspense>
        </QueryErrorBoundary>
    )
}
